import { render, staticRenderFns } from "./SellerDashboard.vue?vue&type=template&id=64f41263&scoped=true"
import script from "./SellerDashboard.vue?vue&type=script&lang=js"
export * from "./SellerDashboard.vue?vue&type=script&lang=js"
import style0 from "./SellerDashboard.vue?vue&type=style&index=0&id=64f41263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f41263",
  null
  
)

export default component.exports